import "src/lib/sentry.ts"; // must be near top
import { createRoot } from "react-dom/client";
import { App } from "./App/App.tsx";
import {
  fetchClientConfig,
  setClientConfig,
} from "src/client-config/getClientConfig.ts";

window.__APP_BOOTED__ = true;

const rootElement = document.getElementById("root")!;

fetchClientConfig().then((config) => {
  setClientConfig(config);
  const root = createRoot(rootElement);
  root.render(<App config={config} />);
});
